goog.provide('el8.appchart.refpanel.confidential');

goog.require('el8.appchart.metrics');
goog.require('el8.appchart.permissions');
goog.require('el8.ptdata.confidentialItems');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appchart.refpanel.RefPanelSection');
goog.require('el8.uiwidget.listeditor');

el8.appchart.refpanel.confidential = (function() {

    var listeditor = null;
    var idPrefix = 'rp_confidential';

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('confidential');

    var that = new el8.appchart.refpanel.RefPanelSection({

        initFn: function() {
            var container = $('#confidential-section');
            that.addContainer(container);
            el8.uiwidget.collapsible({
                container: container,
                triggerElt: $('#confidential-header'),
                statusElt: $('#confidential-status')
            });

            listeditor = new el8.uiwidget.listeditor({
                list: $('#confidential-list'),
                noRemove: true,
                infoText: 'add confidential item',
                idPrefix: idPrefix,
                dropdownFn: (function() {
                    return function($target, id) {
                        var confidentialItem = el8.ptdata.confidentialItems.getById(id);
                        el8.appchart.refpanel.actionsMenu.display(
                            $target, confidentialItem, {top: 14, left: 20}, el8.appshared.feedItemActions(confidentialItem)
                        );
                        return false;
                    };
                })(),
                saveFn: function(id, text, index, opts) {
                    if (id) {
                        var confidentialItem = el8.ptdata.confidentialItems.getById(id);
                        if (confidentialItem.getDescription() !== text) {
                            // if an existing item's text changed, update it
                            confidentialItem.setDescription(text);
                            return el8.ptdata.confidentialItems.saveItem(confidentialItem, true, opts);
                        } else {
                            // if the text didn't change, we still need to run the successCb and return the item
                            if (opts && opts.successCb) {
                                opts.successCb(confidentialItem);
                            }
                            return confidentialItem;
                        }
                    } else {
                        // and this is a new entry in the list
                        return el8.ptdata.confidentialItems.saveNew({
                            id: null,
                            description: text
                        }, true, opts);
                    }
                },
                removeFn: function(id) {
                    return el8.ptdata.confidentialItems.deleteItem(id);
                },
                sortable: false,
                getItemTextFn: function(item) { return item.getDescription(); },
                getItemIdFn: function(item) { return item.getId(); }
            }).init();
        },
        dataRenderers: [
            {
                entitySet: el8.ptdata.confidentialItems,
                listenFn: function() {
                    $('#confidential-list').removeClass('el8Loading');
                    
                    var allItems = el8.ptdata.confidentialItems.sorted();
                    listeditor.addEntries(allItems);

                    reportOnFirstLoad();
                }
            }
        ]
    });

    that.editItem = function(id) {
        if (!id) { return null; }
        var $entry = $('#'+idPrefix+'_'+id, $('#confidential-section'));
        listeditor.editEntry($entry);
    };

    that.removeItem = function(id) {
        if (!id) { return null; }
        var $entry = $('#'+idPrefix+'_'+id, $('#confidential-section'));
        listeditor.removeEntry($entry, true);
    };

    return that;

})();

